var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.27 257.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#eab778;}.cls-3{fill:#322d2b;}.cls-4{fill:#423b31;}.cls-5{fill:#002d55;}.cls-6{fill:#156868;}.cls-7{fill:#c69967;}.cls-8{fill:#23929b;}.cls-9{fill:#ffa895;}.cls-10{fill:#b78858;}.cls-11{fill:#ff807d;}.cls-12{fill:#5b3023;}.cls-13{fill:#fbc2af;}.cls-14{fill:#ec8365;}.cls-15{fill:#1d7a7c;}.cls-16{fill:#6f3c29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m195.66,240.57s-26.73-14.21-28.42-44.25c-1.69-30.05,54.58-55.76,54.04-89.62-.55-33.86-71.93-31.76-54.08-57.8,12.57-18.34.88-37.23-52.49-46.93-72.03-13.1-30.91,42.45-30.6,68.68.31,26.23-103.23,77.91-52.06,169.93h163.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m124.16,215.62c14.97.91,29.94-5.84,43.44-15.56,3.58,27.48,28.06,40.51,28.06,40.51H32.05c-21.64-38.02-17.29-70.85,2.5-102.47,38.62,15.02,49.96,75.1,89.61,77.52Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 109.54,
    cy: 246.48,
    rx: 109.54,
    ry: 11.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m149.09,35.89c0-2.22-1.82-1.99-3.01-1.6,6.28-13.58-2.5-18.37-2.5-18.37-16.28-15.64-24.95,1.76-24.95,1.76-7.13,4.23-.92,14.68-.92,14.68l16.91,9.87c1.9-.53,3.52-1.17,4.93-1.88,0,0,0,0,0,0-.25,4.64,4.14,6.07,9.23,1.87,5.09-4.21.3-6.33.3-6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m149.09,35.89c0-2.22-1.82-1.99-3.01-1.6,1.58-3.41,2.21-6.27,2.26-8.64-4.71,5.44-12.47,8.33-19.45,8.88-2.64.21-5.29.11-7.89-.26l13.63,7.95c1.9-.53,3.52-1.17,4.93-1.88,0,0,0,0,0,0-.25,4.64,4.14,6.07,9.23,1.87,5.09-4.21.3-6.33.3-6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m69.97,80.37l-3.54-.69s-2.71-2.01-4.13-2.27c-1.42-.26-2.4.06-2.4.06l.21.65,2.36.92s-2.55,1.44-4.18,1.25c-1.63-.19-5.15-.61-5.15-.61l-.72,3.34s6.9,3.34,9.11,3.46c2.22.12,7.8-1.4,7.8-1.4l.64-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m116.72,51.41l-1.13-1.72s-4.44,2.28-8.76,8.16c-4.31,5.88-11.32,24.91-11.32,24.91l-27.74-2.99.86,5.57,33.51,10.41,11.88-20.57,2.69-23.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m121.74,224s5.07,9.22,5.07,12.23-3.31,7.62-8.08,7.92c-3.58.22-4.46,5.75-4.46,5.75h13.76l7.5-12.95-3.38-16.63-10.43,3.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "108.38 84.96 107.72 74.69 110.06 82.05 108.38 84.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m131.41,241.55c-.87-2.53-3.72-2.93-5.16-2.97-1.34,2.5-3.75,5.15-7.51,5.57-3.91.43-4.46,5.75-4.46,5.75h13.76l5.78-9.98c-1.62.93-2.41,1.63-2.41,1.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "107.72 121.82 97.29 166.98 118.91 222.38 130.42 218.25 115.35 164.97 133.25 118.74 107.72 121.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "116.41 220.63 129.79 215.75 129.79 221.26 119.16 224.88 116.41 220.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.93 125.12 140.83 176.79 140.83 224.88 129.17 224.88 125.01 177.56 121.83 120.29 144.93 125.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m137.21,48.09s7.93.19,12.06,4.88c4.13,4.69,16.13,27.48,17.35,30.67,1.22,3.19-20.82,25.61-20.82,25.61l-5.25-5.16,14.35-19.14-10.32-10.79s-4.88,26.08-4.69,27.11c.19,1.03,5.53,14.55,5.91,23.84h-39.59s5.81-27.08,6.2-31.72c.94-11.34-8.57-17.77-3.37-30.81,4.27-10.69,6.56-12.91,6.56-12.91l7.83-2.52,13.79.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "121.09 47.78 119.72 59.47 126.95 55.6 134.39 61.04 138.4 48.18 136.44 47.47 123.42 47.17 121.09 47.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m140.52,24.44c-1.3,4.32-1.02,6.22-1.02,6.22,2.92-4,7.13-1.4,5.94,2.16-1.19,3.56-5.94,3.46-5.94,3.46l-4.86,5.94.78,5.37c-2.91,3.1-7.54,6.31-7.54,6.31-1.97-2.39-3.06-6.31-3.06-6.31l1.73-4.61c-11.04-1.21-9-19.68-9-19.68,0,0,8.82,4.13,15.47,4.06l-2.75-5.21s3.86,3.37,6.46,3.42c3.16.07,3.79-1.12,3.79-1.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "126.53 42.98 133.45 42.44 124.81 47.59 126.53 42.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m140.55,104.09s-2.06-1.59-3.66-2.16c-1.59-.56-7.15,3.1-7.15,3.1,0,0,2.27,4.32,2.84,4.6.56.28,4.88-.56,4.88-.56,0,0,4.22,2.35,8.35.19l-5.25-5.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.58 74.17 140.83 69.85 143.74 78.73 144.58 74.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "154.9 84.96 158.65 80.55 153.34 83.33 154.9 84.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "127.54 222.38 142.42 222.38 142.42 227.26 128.04 227.26 127.54 222.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m130.54,227.26s1.45,9.45.63,14.01c-.75,4.13-13.51.88-13.88,8.63h22.26l1-22.64h-10.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m133.29,247.15c-.93-2.65-2.62-3.74-3.96-4.08-3.08,1.07-11.9.41-12.04,6.84h22.26l.19-4.39c-3.34,3.96-6.45,1.64-6.45,1.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "130.54 227.26 140.38 231.02 140.55 227.26 130.54 227.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "140.55 104.09 144.1 109.9 145.8 109.25 140.55 104.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "95.52 82.75 100.21 83.93 96.21 80.92 95.52 82.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "67.81 79.95 68.64 85.34 66.93 85.68 67.81 79.95"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.49fcad5c1b507105160a1677ff2e699b.svg";
export { ForwardRef as ReactComponent };